// extracted by mini-css-extract-plugin
export default {"style":"Paper_style__7vd0x"};